import React from 'react'
import Radium from 'radium'
import colors from '../../../../theme/colors'
import Width from '../../../Width'

export default ({ component: Component, active }) => {
  const Icon = Radium(Component)

  return (
    <Width>
      {({ isSmall }) => (
        <Icon
          style={[
            styles.container,
            isSmall && styles.small.container,
            active && styles.active.container,
          ]}
        />
      )}
    </Width>
  )
}

const styles = {
  container: {
    width: '25px',
    fill: colors.green,
  },
  active: {
    container: {
      fill: colors.white,
    },
  },
  small: {
    container: {
      width: 'initial',
      height: '30px',
    },
  },
}
